/**
 * Route for `offer-checker`. Registered via createRoute; root wires into
 * router.tsx post-merge. Breadcrumb label: "Offer Checker".
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { OfferCheckerPage } from "../features/offer-checker/OfferCheckerPage";

export const offerCheckerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/offer-checker",
	component: OfferCheckerPage,
});

export default offerCheckerRoute;
